import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Seo from '../components/seo/Seo.jsx';
import './NotFound.css';

/**
 * Shown for any path that doesn't match a page.
 * @returns {JSX.Element} Not-found page
 */
function NotFound() {
  const { t } = useTranslation();

  return (
    <section className="not-found">
      <Seo title={`${t('notFound.title')} – Revetall`} description={t('seo.description')} />
      <meta name="robots" content="noindex" />
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <Link to="/" className="button button-primary">
        {t('notFound.link')}
      </Link>
    </section>
  );
}

export default NotFound;
